import { createTheme } from "@mui/material/styles";

// Theme based on the DiskHub logo: green accent on black.
const GREEN = "#1FD62E";

const appTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: GREEN,
      light: "#5CF06A",
      dark: "#12A821",
      contrastText: "#062B0C",
    },
    secondary: { main: "#5CF06A" },
    background: {
      default: "#000000",
      paper: "#0E0E0E",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#9AA0A6",
    },
    divider: "rgba(255,255,255,0.08)",
    success: { main: GREEN },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 16 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, textTransform: "none", fontWeight: 700 },
      },
    },
  },
});

export default appTheme;
